.c-alert {
  --c-alert-color: var(--c-primary-600);

  display: grid;
  gap: 16px;
  grid-template-columns: 1fr;
  color: var(--c-alert-color);
  border: 2px solid currentColor;
  border-left-width: 12px;
  border-radius: 6px;
  padding: 12px;

  &--info,
  &--error,
  &--success,
  &--warning {
    grid-template-columns: auto 1fr;
  }

  &--info {
    --c-alert-color: var(--c-info-600);
  }

  &--error {
    --c-alert-color: var(--c-error-600);
  }

  &--success {
    --c-alert-color: var(--c-success-600);
  }

  &--warning {
    --c-alert-color: var(--c-warning-600);
  }

  &__content {
    color: rgba(0, 0, 0, 0.87);
    display: grid;
    align-items: center;
    grid-template-columns: 1fr;
    gap: 8px;
  }
}

svg {
  fill: currentColor;
}

::slotted(*[slot="title"]) {
  margin: 0 !important;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
}
